import { render, staticRenderFns } from "./ProductCategoriesDialog.vue?vue&type=template&id=0e836449&scoped=true&"
import script from "./ProductCategoriesDialog.vue?vue&type=script&lang=js&"
export * from "./ProductCategoriesDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProductCategoriesDialog.vue?vue&type=style&index=0&id=0e836449&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e836449",
  null
  
)

export default component.exports